import { Component, OnInit } from '@angular/core';

declare const $: any;

@Component({
  selector: 'app-preferences',
  templateUrl: './knowledge-base.component.html',
  styleUrls: ['./knowledge-base.component.scss'],
})
export class KnowledgeBaseComponent implements OnInit {
  public isFindCourse: boolean = false;
  public isCategories: boolean = false;
  public isUpcomingCourses: boolean = false;

  constructor() {}

  ngOnInit(): void {}

  checkcontent(articleselect) {
    localStorage.setItem('articleselect', articleselect);
  }
}
